module.exports = __webpack_public_path__ + "dafba84c6c06b87a0132aa419eb44057.svg";